import React from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import FitnessProfileThisWeekCalendar from '../FitnessProfileThisWeekCalendar';

export default function FitnessProfileThisWeekSection({ profile }) {
	const hasPlan =
		profile.weeklyMealPlan?.length > 0 || profile.weeklyWorkoutSchedule?.length > 0;
	if (!hasPlan) return null;

	return (
		<div className="mt-4">
			<FitnessProfileSectionCard title="This Week" subtitle="Meals + workouts by day">
				<FitnessProfileThisWeekCalendar
					meals={profile.weeklyMealPlan || []}
					workouts={profile.weeklyWorkoutSchedule || []}
					mealBullets={profile.mealPlanBullets || []}
					workoutBullets={profile.workoutPlanBullets || []}
				/>
			</FitnessProfileSectionCard>
		</div>
	);
}
